import { FaUtensils } from "react-icons/fa";
import FoodDetailThemeBase from "./FoodDetailThemeBase";

const BLACK = "#151515";
const YELLOW = "#F5C518";

const theme = {
  pageStyle: { backgroundColor: BLACK },
  headerClassName: "sticky top-0 z-20 border-b border-white/10",
  headerStyle: { backgroundColor: BLACK },
  headerInnerClassName: "mx-auto flex h-16 max-w-2xl items-center justify-between px-4",
  iconButtonClassName: "flex h-11 w-11 items-center justify-center rounded-xl text-xl text-white hover:bg-white/10",
  titleClassName: "font-black text-white",
  badgeClassName: "absolute -left-1 -top-1 rounded-full px-1.5 text-[10px] font-black",
  badgeStyle: { backgroundColor: YELLOW, color: BLACK },
  cardClassName: "overflow-hidden rounded-2xl",
  cardStyle: { backgroundColor: "#1F1F1F" },
  PlaceholderIcon: FaUtensils,
  placeholderClassName: "flex aspect-[4/3] items-center justify-center text-6xl sm:aspect-[16/9]",
  placeholderStyle: { color: YELLOW },
  itemTitleClassName: "text-2xl font-black text-white",
  descriptionClassName: "mt-3 leading-7 text-white/50",
  priceStyle: { color: YELLOW },
  stepperClassName: "flex items-center rounded-full text-white",
  stepperStyle: { backgroundColor: "#1F1F1F" },
  ctaClassName: "min-h-12 flex-1 rounded-full px-5 font-black shadow-lg",
  ctaStyle: { backgroundColor: YELLOW, color: BLACK },
};

const StreetFoodFoodDetailTheme = (props) => <FoodDetailThemeBase {...props} theme={theme} />;

export default StreetFoodFoodDetailTheme;
